import { initFormKitSchema } from "shared/utils/initFormKitSchema";
import store from "shared/store/index";
import { createApp, defineAsyncComponent } from "vue";
import "./FormBuilder.scss";

const formkitBuilderContainerApps = [
	...document.querySelectorAll("[data-form-builder-block]"),
];
formkitBuilderContainerApps.forEach((appContainer, index) => {
	const app = createApp({
		name: `form-builder-block-app-${index}`,
	});
	app.use(store);
	app.component(
		"form-builder-block",
		defineAsyncComponent(() => import("./FormBuilderBlock.vue")),
	);
	app.component(
		"form-kit-builder-container",
		defineAsyncComponent(() => import("./FormKitBuilderContainer.vue")),
	);
	app.component(
		"cm-reorder-form",
		defineAsyncComponent(
			() =>
				import("../../ComfortMedicalWeb/Views/CmReorderForm/CmReorderForm.vue"),
		),
	);
	initFormKitSchema(app);
	app.mount(appContainer);
});
